import script from "./FileTree.vue?vue&type=script&setup=true&lang=js"
export * from "./FileTree.vue?vue&type=script&setup=true&lang=js"

import "./FileTree.vue?vue&type=style&index=0&id=12d6b688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d6b688"]])

export default __exports__